import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Modules } from './components/Modules';
import { WhatsInside } from './components/WhatsInside';
import { Comparison } from './components/Comparison';
import { Bonuses } from './components/Bonuses';
import { FinalOffer } from './components/FinalOffer';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  useEffect(() => {
    try {
      if (typeof window === 'undefined') return;
      // Skip pixel inside the preview iframe to avoid cross-origin "Script error" noise.
      // It will load normally on the live deployed page (top-level window).
      const inIframe = window.self !== window.top;
      if (inIframe) return;
      if ((window as any).__fbqLoaded) return;
      (window as any).__fbqLoaded = true;
      const f: any = window;
      f.fbq = f.fbq || function () {
        ;
        (f.fbq.q = f.fbq.q || []).push(arguments);
      };
      f.fbq.l = +new Date();
      const s = document.createElement('script');
      s.async = true;
      s.src = 'https://connect.facebook.net/en_US/fbevents.js';
      s.onerror = () => {
        /* swallow load failures silently */
      };
      document.head.appendChild(s);
      f.fbq('init', '1252242806993118');
      f.fbq('track', 'PageView');
    } catch {
      /* pixel optional — never block render */
    }
  }, []);
  return <div className="w-full min-h-screen bg-white text-slate-900" data-id="element-0">
      <Hero data-id="element-1" />
      <PainPoints data-id="element-2" />
      <Modules data-id="element-3" />
      <WhatsInside data-id="element-4" />
      <Comparison data-id="element-5" />
      <Bonuses data-id="element-6" />
      <FinalOffer data-id="element-7" />
      <Testimonials data-id="element-8" />
      <FAQ data-id="element-9" />
      <Footer data-id="element-10" />
      <PurchasePopup data-id="element-11" />
    </div>;
}